// All services are to be used only for server-side data fetching
// Any client-side data should be retrieved via Next API routes and 'swr'

import ApiClient from './api-client';
import AppCardService from './app-card-service';
import AppDetailsService from './app-details-service';
import DownloadService from './download-service';
import DynamicContentService from './dynamic-content-service';
import IdentityService from './identity-service';
import MicrositeService from './microsite-service';
import PackageService from './package-service';
import SearchService from './search-service';
import VerifyService from './verify-service';

export {
  ApiClient,
  AppDetailsService,
  MicrositeService,
  PackageService,
  SearchService,
  DynamicContentService,
  DownloadService,
  IdentityService,
  AppCardService,
  VerifyService,
};
